import Chip from "../../../../stories/Components/Chip";
import { ChipProps } from "../../../../stories/Components/Chip/interface";
import classes from "./preferenceDialog.module.scss";
interface PreferenceItemsProps {
    preferenceItems: ChipProps[];
}

const PreferenceItems = ({ preferenceItems }: PreferenceItemsProps) => {
    return (
        <div className={classes.chipContainer}>
            {preferenceItems.map((item) => {
                const { label, active } = item;
                return (
                    <Chip
                        key={`shortcut-chip-${label}`}
                        label={label}
                        onClick={() => {
                            item.active = !item.active;
                        }}
                        disabled={false}
                        active={active}
                    />
                );
            })}
        </div>
    );
};

export default PreferenceItems;
